import { render, staticRenderFns } from "./summer.vue?vue&type=template&id=38fb633b&scoped=true"
import script from "./summer.vue?vue&type=script&lang=js"
export * from "./summer.vue?vue&type=script&lang=js"
import style0 from "./summer.vue?vue&type=style&index=0&id=38fb633b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fb633b",
  null
  
)

export default component.exports